<!-- =========================================================================================
  File Name: StudentEdit.vue
  Description: Student Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-student-edit">

    <vs-alert color="danger" title="Student Not Found" :active.sync="student_not_found">
      <span>Student record with id: {{ $route.params.userID }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-student-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <!-- <vx-card v-if="student_data"> -->
    <vx-card title="학생 상세 정보" class="mb-base" v-if="student_data">
      <student-edit-form class="mt-4" :data="student_data" />

    </vx-card>
  </div>
</template>

<script>
import StudentEditForm  from './StudentEditForm.vue'
import { fetchData } from '@/api/module'

export default {
  components: {
    StudentEditForm
  },
  data () {
    return {
      student_data: null,
      student_not_found: false
    }
  },
  async created () {
    try {
      const studentID = this.$route.params.studentID
      const { data } = await fetchData(`student/${studentID}`)
      // console.log(data);
      this.student_data = data.data
    } catch (error) {
      this.$vs.notify({
        title: 'Error',
        text: error.response.data.msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      }) 
    }
  } 
}

</script>
